import { render, staticRenderFns } from "./SorteioLista.vue?vue&type=template&id=52d2a1f7&scoped=true"
import script from "./SorteioLista.vue?vue&type=script&lang=js"
export * from "./SorteioLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2a1f7",
  null
  
)

export default component.exports